module.exports = __webpack_public_path__ + "static/media/cross.f72b9055.svg";